export const PartTypeEnum = Object.freeze({
	UNKNOWN: "UNKNOWN",
	PROTECTOR: "PROTECTOR",
	EXILE: "EXILE",
})
